<template>
  <el-dialog title="标签打印" :visible.sync="showPrintView" width="800px">
    <el-form
      ref="printFormRef"
      direction="vertical"
      :model="detail"
      :rules="rules"
    >
      <el-descriptions :column="2" border size="">
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.form_label_amzSkuNo') || '产品SKU编号' }}
          </template>
          {{ detail.amzSkuNo }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('table_label_scm') || '生产厂家' }}
          </template>
          <el-form-item prop="amzSkuFtyCode">
            <el-select
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              v-model="detail.amzSkuFtyCode"
              @change="changeScmCode"
            >
              <el-option
                v-for="item in optionData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="scm-select"
              >
                <span class="scm-select-item">{{ item.label }}</span>
                <span
                  class="scm-select-item"
                  style="color: #8492a6; font-size: 13px"
                  >NC: {{ item.ncNo }}</span
                >
              </el-option>
            </el-select>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.table_label_brandName') || '品牌' }}
          </template>
          {{ detail.brandName }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.amz_sku_inv_query_ncNo') || 'NC编号' }}
          </template>
          {{ detail.ncNo }}
        </el-descriptions-item>
        <el-descriptions-item span="2" label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_goodsNameCn') || '中文名称' }}
          </template>
          {{ detail.goodsName }}
        </el-descriptions-item>
        <el-descriptions-item span="2" label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_goodsNameEn') || '英文名称' }}
          </template>
          {{ detail.goodsNameEn }}
        </el-descriptions-item>
        <el-descriptions-item span="2" label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_goodsSize') || '产品尺寸' }}
          </template>
          {{ detail.goodsSize }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.form_label_goodsColor') || '颜色' }}
          </template>
          {{ detail.goodsColor }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('form_label_collectionName') || '系列' }}
          </template>
          {{ detail.collectionName }}
        </el-descriptions-item>
        <el-descriptions-item label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_inCtnQty') || '装箱入数' }}
          </template>
          <el-input-number
            v-model="detail.inCtnQty"
            controls-position="right"
            :min="1"
            :max="99999"
          >
          </el-input-number>
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('form_label_printNumber') || '打印数量' }}
          </template>
          <el-input-number
            v-model="detail.printNumber"
            controls-position="right"
            :min="1"
            :max="99999"
          >
          </el-input-number>
        </el-descriptions-item>
      </el-descriptions>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPrintView = false">取 消</el-button>
      <el-button type="primary" @click="print">打 印</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      showPrintView: false,
      amzSkuNo: '',
      amzSkuCode: '',
      detail: {},
      optionData: [],
      rules: {
        amzSkuFtyCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    getData() {
      this.$api
        .ecomAmzSkuFtyPrintScmListApi({
          amzSkuCode: this.amzSkuCode,
        })
        .then((res) => {
          this.optionData = res.body.data
        })
      this.$api
        .ecomAmzSkuDetailPrintViewApi({
          amzSkuCode: this.amzSkuCode,
        })
        .then((res) => {
          this.detail = res.body
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    open(amzSkuCode) {
      this.amzSkuCode = amzSkuCode
      this.showPrintView = true
      this.getData()
    },
    changeScmCode(amzSkuFtyCode) {
      if (amzSkuFtyCode) {
        this.$api.ecomAmzSkuFtyScmNcNoApi({ amzSkuFtyCode }).then((res) => {
          this.detail.ncNo = res.body
        })
      } else {
        this.detail.ncNo = ''
      }
    },
    print() {
      this.$refs['printFormRef'].validate((valid) => {
        if (valid) {
          let data = {
            amzSkuCode: this.amzSkuCode,
            ncNo: this.detail.ncNo,
            inCtnQty: this.detail.inCtnQty,
            printNumber: this.detail.printNumber,
          }
          let fileName = `亚马逊SKU标签_${this.detail.amzSkuNo}_${this.detail.ncNo}_入数${this.detail.inCtnQty}_${this.detail.printNumber}张`
          this.$api.globalExportData('/ecom/amz/sku/print', data, fileName)
        } else {
          return
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.print-view-label {
  width: 124px !important;
}
.print-view-content {
  width: 255px !important;
}
.scm-select {
  height: auto !important;
  line-height: 20px !important;
  margin: 15px 0;
  .scm-select-item {
    display: block;
  }
}
</style>
